import { render } from "./Details.vue?vue&type=template&id=6f845096&scoped=true&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=6f845096&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f845096"]])

export default __exports__